// extracted by mini-css-extract-plugin
module.exports = {"orderDetailsContainer":"OrderDetails_orderDetailsContainer__22puc","orderDetailsContainerRow":"OrderDetails_orderDetailsContainerRow__36EZB"};